import { PageRelationshipType, PageType } from '../../types/__generated__';

type PageParentRelationship = {
  type: PageRelationshipType;
  page?: { product?: { name: string } | null; type: PageType } | null;
};

export function getCampaigns<T extends PageParentRelationship>(
  relationships: T[],
): NonNullable<T['page']>[] {
  return filterRelatedPages({
    relationships,
    relationshipType: PageRelationshipType.ParticipatesIn,
    productName: ['proxy_campaign', 'campaign'],
    legacyPageType: PageType.Campaign,
  });
}

export function getFirstCampaign<T extends PageParentRelationship>(
  relationships: T[],
): NonNullable<T['page']> | undefined {
  return getCampaigns(relationships)[0];
}

export function getFirstTeam<T extends PageParentRelationship>(
  relationships: T[],
): NonNullable<T['page']> | undefined {
  return filterRelatedPages({
    relationships,
    relationshipType: PageRelationshipType.ParticipatesIn,
    productName: ['proxy_team'],
    legacyPageType: PageType.Team,
  })[0];
}

function filterRelatedPages<T extends PageParentRelationship>({
  relationships,
  relationshipType,
  productName,
  legacyPageType,
}: {
  relationships: T[];
  relationshipType: PageRelationshipType;
  productName: string[];
  legacyPageType: PageType;
}): NonNullable<T['page']>[] {
  return relationships
    .filter(r => {
      if (!r.page || r.type !== relationshipType) {
        return false;
      }

      if (!r.page.product) {
        return r.page.type === legacyPageType;
      }
      return productName.includes(r.page.product.name);
    })
    .map(r => r.page as NonNullable<T['page']>); // TS isn't smart enough to realise that the filter above discards items where r.page is null
}
